
  import { Component, Watch, Prop, Vue, Ref } from 'vue-property-decorator';
  import { Getter, Action } from 'vuex-class';

  @Component({})
  export default class DocumentDateComponent extends Vue {
    menuOne = false;
    menuTwo = false;

    @Prop({ type: Object })
    document;

    get documentDate(): string | null {
      return this.document.documentDate
        ? this.formatDate(new Date(this.document.documentDate).toISOString().substr(0, 10))
        : null;
    }
    set documentDate(value: string | null) {
      this.document.documentDate = this.parseDate(value);
    }

    get expirationDate(): string | null {
      return this.document.expirationDate
        ? this.formatDate(new Date(this.document.expirationDate).toISOString().substr(0, 10))
        : null;
    }
    set expirationDate(value: string | null) {
      this.document.expirationDate = this.parseDate(value);
    }

    @Watch('menuOne')
    private async mnuOne(val) {
      val && setTimeout(() => ((this.$refs['pickerOne'] as any).activePicker = 'YEAR'));
    }

    @Watch('menuTwo')
    private async mnuTwo(val) {
      val && setTimeout(() => ((this.$refs['pickerTwo'] as any).activePicker = 'YEAR'));
    }

    formatDate(date): any {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    }

    parseDate(date): any {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
